import { QuestionTime } from 'shared/daytime';

export interface Question {
  _id: string;
  title: Dictionary<string>;
  description: Dictionary<string>;
  type: QuestionTypeBase;
  isSystemQuestion: boolean;
}

interface QuestionTypeBase {
  name: string;
}

export type AnswerType = number | string | Array<number> | Array<string>;

export type TipList = Array<Tip>;

export interface Tip {
  _id: string;
  text: Dictionary<string>;
  goal?: boolean;
}

export interface TipRating {
  tip: Tip;
  createdAt: string;
  updatedAt: string;
  rating: number;
}

export interface ButtonList extends QuestionTypeBase {
  name: 'buttonlist';
  buttons: Array<Dictionary<string>>;
}

export interface SliderKeypoint {
  title: Dictionary<string>;
  value: number;
}

export interface SkippedQuestion {
  questionId: string;
  answerExpectedAt: Date;
}

interface SliderBase extends QuestionTypeBase {
  minText: Dictionary<string>;
  maxText: Dictionary<string>;
  keyPoints: Array<SliderKeypoint>;
  isSnapping: boolean;
}

export interface Slider extends SliderBase {
  name: 'slider';
}

export interface MultiSlider extends QuestionTypeBase {
  name: 'multislider';
  sliders: Array<Slider>;
  isSnapping: boolean;
}

export interface Message extends QuestionTypeBase {
  name: 'message';
}

export interface YesNo extends QuestionTypeBase {
  name: 'yesno';
}

export interface EnergyLevel extends SliderBase {
  name: 'energylevel';
}

export interface PerformanceLevel extends SliderBase {
  name: 'performancelevel';
}

export interface Rating extends QuestionTypeBase {
  name: 'rating';
  minText: Dictionary<string>;
  maxText: Dictionary<string>;
}
